import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import { post, get } from "../../../helpers/api_helper";
import {
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import {
  POST_GetMachiningOutwardInwardDetailByID,
  POST_MachiningOutwardInwardDelete,
  POST_MachiningOutwardInwardInsert,
} from "../../../helpers/url_helper";

const AddMachineInward = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  //const [selectedCheckbox, setSelectedCheckbox] = useState(1);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    // InwardRemarks: Yup.string()
    //   .trim()
    //   .required("Inward Remarks is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MachiningOutwardIDEncrypt: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      VendorIDEncrypt: "",
      VendorName: "",
      MachiningOutwardNo: "",
      OutwardDate: "",
      ExpectedDate: "",
      Remarks: "",
      InwardRemarks: "",
      ListOfVendorProcessDetail: [],
      ListOfVendorProcessDetailFinal: [],
      ListOfVendorProcessDetailSelected: [],
      ProcessSearch: "",
      TCNoSearch: "",
      ProcessNoteSearch: "",
      QtySearch: "",
      LengthSearch: "",
      ThicknessSearch: "",
      OutwardStatus: 1,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      MachiningOutwardIDEncrypt,
      ListOfVendorProcessDetail,
      ListOfVendorProcessDetailFinal,
      ListOfVendorProcessDetailSelected,
      ProcessSearch,
      TCNoSearch,
      ProcessNoteSearch,
      QtySearch,
      LengthSearch,
      ThicknessSearch,
      OutwardStatus,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      ListOfVendorProcessDetail?.filter((x) => x.IsSelected == true)?.length ==
      0
    ) {
      formik.setFieldError(
        "ListOfVendorProcessDetail",
        "Process Detail is required"
      );
      formik.setFieldTouched("ListOfVendorProcessDetail", true);

      return;
    }

    setIsLoading(true);

    let ProcessDetailList = [];

    ProcessDetailList = values?.ListOfVendorProcessDetail?.map((item) => ({
      MachiningOutwardDetailIDEncrypt: item?.MachiningOutwardDetailIDEncrypt,
      MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
      InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
      InwardMachiningDetailIDEncrypt: item?.InwardMachiningDetailIDEncrypt,
      Invoicing: item?.IsSelectedInvoicing,
      IsSelected: item?.IsSelected,
    }));

    let payload = {
      // ...values,
      MachiningOutwardIDEncrypt: values?.MachiningOutwardIDEncrypt,
      InwardRemarks: values?.InwardRemarks?.trim(),
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      MachiningOutwardDetails: ProcessDetailList,
    };

    post(PrimaryIdParam ? POST_MachiningOutwardInwardInsert : "", payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/machining-outward-list");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    //console.log("Save", ListOfVendorProcessDetail);
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      getMachiningOutwardDetails();
    }
  }, []);

  const getMachiningOutwardDetails = async () => {
    setIsLoading(true);

    if (MachiningOutwardIDEncrypt) {
      await post(POST_GetMachiningOutwardInwardDetailByID, {
        MachiningOutwardIDEncrypt: MachiningOutwardIDEncrypt,
        CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
        ViewType: 1, // Only Outward Display
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setValues({
              MachiningOutwardIDEncrypt: response?.MachiningOutwardIDEncrypt,
              VendorIDEncrypt: response?.VendorIDEncrypt,
              VendorName: response?.VendorName,
              MachiningOutwardNo: response?.MachiningOutwardNo,
              OutwardDate: response?.OutwardDate,
              ExpectedDate: response?.ExpectedDate,
              Remarks: response?.OutwardRemarks,
              InwardRemarks: response?.InwardRemarks,
              OutwardStatus: response?.OutwardStatus,

              ListOfVendorProcessDetail: response?.MachiningOutwardDetails?.map(
                (item) => ({
                  MachiningConfigurationIDEncrypt:
                    item?.MachiningConfigurationIDEncrypt,
                  InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
                  InwardMachiningDetailIDEncrypt:
                    item?.InwardMachiningDetailIDEncrypt,
                  ProcessName: item?.ProcessName,
                  TCNo: item?.TCNo,
                  Note: item?.MachiningNote,
                  Qty: item?.Qty,
                  Length: item?.Length,
                  Thickness: item?.Thickness,
                  VendorRate: item?.VendorRate,
                  InvoiceRate: item?.InvoiceRate,
                  IsDelete: item?.IsDelete,
                  IsSelectedInvoicing: item?.Invoicing,
                  IsSelected: item?.IsSelected,
                  MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
                  MachiningOutwardDetailIDEncrypt:
                    item?.MachiningOutwardDetailIDEncrypt,
                  OutwardStatus: item?.OutwardStatus,
                  display: true,
                  IsHold: item?.IsHold,
                  HoldReason: item?.HoldReason,
                })
              ),

              ListOfVendorProcessDetailFinal:
                response?.MachiningOutwardDetails?.map((item) => ({
                  MachiningConfigurationIDEncrypt:
                    item?.MachiningConfigurationIDEncrypt,
                  InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
                  InwardMachiningDetailIDEncrypt:
                    item?.InwardMachiningDetailIDEncrypt,
                  ProcessName: item?.ProcessName,
                  TCNo: item?.TCNo,
                  Note: item?.MachiningNote,
                  Qty: item?.Qty,
                  Length: item?.Length,
                  Thickness: item?.Thickness,
                  VendorRate: item?.VendorRate,
                  InvoiceRate: item?.InvoiceRate,
                  IsDelete: item?.IsDelete,
                  IsSelectedInvoicing: item?.Invoicing,
                  IsSelected: item?.IsSelected,
                  MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
                  MachiningOutwardDetailIDEncrypt:
                    item?.MachiningOutwardDetailIDEncrypt,
                  OutwardStatus: item?.OutwardStatus,
                  display: true,
                  IsHold: item?.IsHold,
                  HoldReason: item?.HoldReason,
                })),

              ListOfVendorProcessDetailSelected:
                response?.MachiningOutwardDetails?.map((item) => ({
                  MachiningConfigurationIDEncrypt:
                    item?.MachiningConfigurationIDEncrypt,
                  InwardMaterialIDEncrypt: item?.InwardMaterialIDEncrypt,
                  InwardMachiningDetailIDEncrypt:
                    item?.InwardMachiningDetailIDEncrypt,
                  ProcessName: item?.ProcessName,
                  TCNo: item?.TCNo,
                  Note: item?.MachiningNote,
                  Qty: item?.Qty,
                  Length: item?.Length,
                  Thickness: item?.Thickness,
                  VendorRate: item?.VendorRate,
                  InvoiceRate: item?.InvoiceRate,
                  IsDelete: item?.IsDelete,
                  IsSelectedInvoicing: item?.Invoicing,
                  IsSelected: item?.IsSelected,
                  MachiningOutwardIDEncrypt: item?.MachiningOutwardIDEncrypt,
                  MachiningOutwardDetailIDEncrypt:
                    item?.MachiningOutwardDetailIDEncrypt,
                  OutwardStatus: item?.OutwardStatus,
                  display: true,
                  IsHold: item?.IsHold,
                  HoldReason: item?.HoldReason,
                })),
            });
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });

      // setShowMachiningOutwardModal(true);
    }
    setIsLoading(false);
  };

  const handleChangeSearchProcessName = async (
    ProcessSearchText,
    TCNoSearchText,
    ProcessNoteSearchText,
    QtySearchText,
    LengthSearchText,
    ThicknessSearchText
  ) => {
    //alert(ProcessSearchText);
    //console.log("List", ListOfVendorProcessDetailSelected);

    let newList = ListOfVendorProcessDetailSelected?.filter(
      (x, ix) => x.IsSelected == true
    );

    let newListSeleAllFalse = ListOfVendorProcessDetailFinal?.filter(
      (x, ix) => x.IsSelected == false
    );

    // let newListSeleAllFalse = ListOfVendorProcessDetailFinal?.map(
    //   (item, idx) => {
    //     return {
    //       ...item,
    //       IsSelected: false,
    //     };
    //   }
    // );

    // let newListSeleAll = newListSeleAllFalse?.map((item, idx) => {
    //   newList?.map((itemSel, idxSel) => {
    //     if (itemSel.IsSelected == true) {
    //       if (itemSel.ProcessIDEncrypt == item.ProcessIDEncrypt) {
    //         item.IsSelected = true;
    //       }
    //     } else {
    //       item.IsSelected = false;
    //     }
    //   });

    //   return { ...item };
    // });

    let newFinalList = newListSeleAllFalse.filter(
      (x) =>
        x?.ProcessName?.toLowerCase().includes(
          ProcessSearchText?.toLowerCase()
        ) &&
        x?.TCNo?.toLowerCase().includes(TCNoSearchText?.toLowerCase()) &&
        x?.Note?.toLowerCase().includes(ProcessNoteSearchText?.toLowerCase()) &&
        x?.Qty?.toLowerCase().includes(QtySearchText?.toLowerCase()) &&
        x?.Length?.toLowerCase().includes(LengthSearchText?.toLowerCase()) &&
        x?.Thickness?.toLowerCase().includes(ThicknessSearchText?.toLowerCase())
    );

    // console.log("newList", newList);
    // console.log("newListSeleAllFalse", newListSeleAllFalse);
    // console.log("newfinalList", newFinalList);

    formik.setFieldValue("ListOfVendorProcessDetail", [
      ...newList,
      ...newFinalList?.filter((x, ix) => x.IsSelected == false),
    ]);
  };

  const checkProcessDetailSelected = async (e, indx) => {
    // alert(ProcessSearchText);
    //setSelectedCheckbox(itemId);

    if (e?.target?.checked == true) {
      //alert(e?.target?.checked);

      formik.setFieldValue(
        `ListOfVendorProcessDetailSelected`,
        ListOfVendorProcessDetail?.map((item, indxTest) => {
          if (indxTest == indx) {
            return {
              ...item,
              IsSelected: true,
            };
          } else {
            return {
              ...item,
            };
          }
        })
      );
    } else {
      formik.setFieldValue(
        `ListOfVendorProcessDetailSelected`,
        ListOfVendorProcessDetail?.map((item, indxTest) => {
          if (indxTest == indx) {
            if (item.IsSelected == true) {
              return {
                ...item,
                IsSelected: false,
              };
            }
          } else {
            return {
              ...item,
            };
          }
        })
      );
    }

    //...newfinalList?.filter((x, ix) => x.IsSelected == false),
    //  console.log("SelectedList", ListOfVendorProcessDetailSelected);
  };

  const fnCallback = () => {
    navigate("/machining-outward-list");
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {/* {PrimaryIdParam ? "Edit" : "Add"} Machining Inward */}
              Machining Inward
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Vendor"
                      name="VendorName"
                      placeholder={"Vendor Name"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Outward No"
                      name="MachiningOutwardNo"
                      placeholder={"Outward No"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Outward Date"
                      name="OutwardDate"
                      placeholder={"Outward Date"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>

                  <Col lg={3}>
                    <Field
                      label="Expected Date of Return"
                      name="ExpectedDate"
                      placeholder={"Expected Date of Return"}
                      component={CustomInput}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Field
                      label="Remarks"
                      name="Remarks"
                      rows={3}
                      placeholder={"Enter Remarks"}
                      component={CustomTextArea}
                      disabled={true}
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      label="Inward Remarks"
                      name="InwardRemarks"
                      rows={3}
                      placeholder={"Enter Inward Remarks"}
                      component={CustomTextArea}
                      maxLength={500}
                      autoFocus
                    />
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>

                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="VendorProcessDetail-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="VendorProcessDetail-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="2%" className="p-1"></th>
                              <th width="26%" className="p-1">
                                Process
                              </th>
                              <th width="18%" className="p-1">
                                TC No
                              </th>
                              <th width="16%" className="p-1">
                                Note
                              </th>
                              <th width="12%" className="p-1">
                                Qty
                              </th>
                              <th width="12%" className="p-1">
                                Length
                              </th>

                              <th
                                width="14%"
                                className="p-1"
                                style={{ textAlign: "left" }}
                              >
                                Thickness
                              </th>
                              <th
                                width="8%"
                                className="p-1"
                                style={{ textAlign: "center" }}
                              >
                                Invoicing
                              </th>
                            </tr>
                            <tr>
                              <th className="p-1 pt-0"></th>
                              <th width="20%" className="p-1 pt-0">
                                <Field
                                  name="ProcessSearch"
                                  placeholder={"Search Process"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ProcessSearch",
                                      e?.target?.value ?? ""
                                    );

                                    handleChangeSearchProcessName(
                                      e?.target?.value ?? "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="TCNoSearch"
                                  placeholder={"Search TC No"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "TCNoSearch",
                                      e?.target?.value ?? ""
                                    );

                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      e?.target?.value ?? "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="ProcessNoteSearch"
                                  placeholder={"Search Note"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ProcessNoteSearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      e?.target?.value ?? "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="QtySearch"
                                  placeholder={"Search Qty"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "QtySearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      e?.target?.value ?? "",
                                      LengthSearch ? LengthSearch : "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="LengthSearch"
                                  placeholder={"Search Length"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "LengthSearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      e?.target?.value ?? "",
                                      ThicknessSearch ? ThicknessSearch : ""
                                    );
                                  }}
                                />
                              </th>
                              <th width="15%" className="p-1 pt-0">
                                <Field
                                  name="ThicknessSearch"
                                  placeholder={"Search Thickness"}
                                  component={CustomInput}
                                  required
                                  maxLength={100}
                                  noMarginBottom={true}
                                  style={{ height: "2.3rem" }}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ThicknessSearch",
                                      e?.target?.value ?? ""
                                    );
                                    handleChangeSearchProcessName(
                                      ProcessSearch ? ProcessSearch : "",
                                      TCNoSearch ? TCNoSearch : "",
                                      ProcessNoteSearch
                                        ? ProcessNoteSearch
                                        : "",
                                      QtySearch ? QtySearch : "",
                                      LengthSearch ? LengthSearch : "",
                                      e?.target?.value ?? ""
                                    );
                                  }}
                                />
                              </th>
                              <th className="p-1 pt-0 text-center">
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        Only the selected processes will be
                                        considered for invoicing.
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle ms-2"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfVendorProcessDetail?.filter(
                              (x) => x.display == true
                            )?.length > 0 ? (
                              ListOfVendorProcessDetail?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display: item.display == true ? "" : "none",
                                  }}
                                >
                                  <td
                                    style={{
                                      minWidth: "50px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkProcess${indx}`}
                                      name={`chkProcess${indx}`}
                                      checked={item.IsSelected}
                                      disabled={
                                        item?.IsHold
                                          ? true
                                          : item?.OutwardStatus == 2
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        if (item?.IsHold == false) {
                                          formik.setFieldValue(
                                            `ListOfVendorProcessDetail[${indx}].IsSelected`,
                                            e?.target?.checked
                                          );

                                          checkProcessDetailSelected(e, indx);
                                        }
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "150px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.ProcessName}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.TCNo}{" "}
                                    {item?.IsHold == true && (
                                      <>
                                        <b>[Hold]</b>
                                        <OverlayTrigger
                                          trigger={["hover", "focus"]}
                                          key={indx}
                                          responsive={true}
                                          overlay={
                                            <Tooltip className="toltip-popover">
                                              <strong className="p-1">
                                                {item?.HoldReason}
                                              </strong>
                                            </Tooltip>
                                          }
                                        >
                                          <span>
                                            <i
                                              className="fa fa-info-circle ms-2"
                                              style={{
                                                cursor: "pointer",
                                                color: "#9698ab",
                                              }}
                                            ></i>
                                          </span>
                                        </OverlayTrigger>
                                      </>
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "200px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.Note}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.Qty}
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    {item.Length}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "200px",
                                      whiteSpace: "normal",
                                      textAlign: "left",
                                    }}
                                  >
                                    {item.Thickness}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      minWidth: "50px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkInvoicing${indx}`}
                                      name={`chkInvoicing${indx}`}
                                      checked={item.IsSelectedInvoicing}
                                      disabled={true}
                                      // onChange={(e) => {
                                      //   formik.setFieldValue(
                                      //     `ListOfVendorProcessDetail[${indx}].IsSelectedInvoicing`,
                                      //     e?.target?.checked
                                      //   );
                                      // }}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <div>{"No options"}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <ErrorMessage
                      name={"ListOfVendorProcessDetail"}
                      component="div"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    />
                  </Col>
                </Row>
                <div className="stickyBottomButtons">
                  <hr className="mt-1 mb-2"></hr>
                  {OutwardStatus != 3 && (
                    <button
                      type="submit"
                      // className="btn btn-primary"
                      className="btn btn-primary btn-sm me-2"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </button>
                  )}
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                  {OutwardStatus > 1 && (
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm ms-2"
                      style={{ float: "right" }}
                      onClick={(e) => {
                        delete_Record(
                          POST_MachiningOutwardInwardDelete,
                          {
                            MachiningOutwardIDEncrypt:
                              MachiningOutwardIDEncrypt,
                            ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
                              ? AuthUser?.ReferenceIDEncrypt
                              : "0",
                          },
                          setIsLoading,
                          fnCallback,
                          "Machining Inward will be deleted!"
                        );
                      }}
                    >
                      <i className="fa-solid fa-trash"></i> Delete Machining
                      Inward
                    </button>
                  )}
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddMachineInward;
